import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { promptApi, type Prompt } from '../../api/media';

export function PromptLibraryPage() {
  const [prompts, setPrompts] = useState<Prompt[]>([]);
  const [templates, setTemplates] = useState<Prompt[]>([]);

  useEffect(() => {
    void Promise.all([promptApi.list(), promptApi.templates()]).then(([p, t]) => {
      setPrompts(p);
      setTemplates(t);
    });
  }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Prompt Library</h1>
          <p className="mt-1 text-sm text-slate-600">AI prompts, templates, and generation history.</p>
        </div>
        <div className="flex gap-3 text-sm">
          <Link to="/media/prompts/new" className="text-slate-700 hover:underline">New prompt</Link>
          <Link to="/media/generations" className="text-slate-700 hover:underline">Generation history</Link>
          <Link to="/media" className="text-slate-700 hover:underline">← Library</Link>
        </div>
      </div>
      <section className="mt-8">
        <h2 className="font-medium">Templates</h2>
        <ul className="mt-3 space-y-2">
          {templates.map((t) => (
            <li key={t.id} className="rounded-lg border px-4 py-3 text-sm">
              <Link to={`/media/prompts/${t.id}/edit`} className="font-medium hover:underline">{t.name}</Link>
              <p className="text-slate-500 truncate">{t.content}</p>
            </li>
          ))}
          {templates.length === 0 && <p className="text-slate-500">No templates yet.</p>}
        </ul>
      </section>
      <section className="mt-8">
        <h2 className="font-medium">All prompts</h2>
        <ul className="mt-3 space-y-2">
          {prompts.map((p) => (
            <li key={p.id} className="rounded-lg border px-4 py-3 text-sm">
              <Link to={`/media/prompts/${p.id}/edit`} className="font-medium hover:underline">{p.name}</Link>
              <p className="text-slate-500">{p.category || 'general'}</p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
